import SendItems from 'src/components/Dialogs/SendItems';

import { ActionComponentProps } from '../../index';

export const Submit = ({ mailpieces, actionStarted, onActionFinish }: ActionComponentProps) =>
  actionStarted ? (
    <SendItems onClose={onActionFinish} pieces={mailpieces.map(({ id }) => id)} />
  ) : null;
